import { useState } from "react";
import styled from "styled-components";
import { ArrowDownIcon, MoreIcon } from "../../../assets/icons/Icons";
import { movimientos } from "../../../constants/capturaSiniestro";
import { ModalAgregarMovimiento } from "../CapturaSiniestro";
import CardMovimientos from "./CardMovimientos";

export const AgregarMovimientos = ({ onOpenModal }) => {
  const [open, setOpen] = useState(true);
  const [showNewMovement, setShowNewMovement] = useState(false);

  const onButton = () => {
    setOpen(!open)
  };

  return (
    <ModuleContainer open={open}>
      <Header
        onClick={() => {
          onButton();
        }}
      >
        <ModuleTitle>Agregar Movimientos</ModuleTitle>
        <ArrowDownIcon className="arrow-movements" />
      </Header>
      <Content className="content">
        <Divider />
        <TitleWraper>
          <ModuleTitle style={{ color: "var(--primary-royal-blue)" }}>
            Movimientos
          </ModuleTitle>
          <div style={{ position: "relative" }}>
            <MoreIcon
              negative
              onClick={() => setShowNewMovement((prev) => !prev)}
            />
            <ModalAgregarMovimiento
              showNewMovement={showNewMovement}
              setShowNewMovement={setShowNewMovement}
            />
          </div>
        </TitleWraper>
        <TableWrapper>
          <FiltersContainer>
            <FilterButton>#</FilterButton>
            <FilterButton>
              Tipo de Movimiento
              <ArrowDownIcon />
            </FilterButton>
            <FilterButton>Fecha</FilterButton>
            <FilterButton style={{ width: "120px" }}>Monto</FilterButton>
            <FilterButton>
              Moneda <ArrowDownIcon />
            </FilterButton>
          </FiltersContainer>
          <TableContainer>
            {movimientos.map((item) => (
              <CardMovimientos
                id={item.id}
                type={item.tipo}
                amount={item.monto}
                date={item.fecha}
                status={item.estado}
                divisa={item.moneda}
                key={item.id}
                onOpenModal={onOpenModal}
              />
            ))}
          </TableContainer>
        </TableWrapper>
        <Divider />
        <DataContainer>
          <DataText>
            <b>Reserva:</b> {"750,000.00"}
          </DataText>
          <DataText>
            <b>Pago de siniestro:</b> {"$0.00"}
          </DataText>
          <DataText>
            <b>Pago de proovedores:</b> {"$0.00"}
          </DataText>
          <DataText>
            <div>
              <span>
                <b>Recuperación (MXN):</b> {"$0.00"}
              </span>
              <span>
                <b>Recuperación (USD):</b> {"$0.00"}
              </span>
            </div>
          </DataText>
        </DataContainer>
      </Content>
    </ModuleContainer>
  );
};

const ModuleContainer = styled.div`
  background-color: #fff;
  border-radius: 24px;
  padding: 40px;
  width: 1200px;
  display: flex;
  flex-direction: column;
  box-shadow: 19px 70px 29px rgba(4, 3, 63, 0.01),
    11px 40px 25px rgba(4, 3, 63, 0.03), 5px 18px 18px rgba(4, 3, 63, 0.04),
    1px 4px 10px rgba(4, 3, 63, 0.05), 0px 0px 0px rgba(4, 3, 63, 0.05);
  margin-bottom: 30px;
  & > .content {
    display: ${(props) => (props.open ? "block" : "none")};
  }
  & .arrow-movements {
    transition: 500ms;
    transform: ${(props) => (props.open ? "rotate(180deg)" : "rotate(0deg)")};
  }
  @media only screen and (max-width: 768px) {
    width: 90vw;
    padding: 40px 20px;
  }
  @media only screen (min-width: 769px) and (max-width: 1280px) {
    width: 100vw;
    padding: 40px 20px;
  }
`

const Header = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModuleTitle = styled.p`
  color: var(--neutrals-charcoal);
  font-size: 24px;
  font-weight: 700;
`;

const TitleWraper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Content = styled.div``;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  margin: 24px 0;
  background-color: var(--primary-pistachio);
`;

//==== TABLE ====//
const TableWrapper = styled.div`
  margin: 20px 0;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  padding-bottom: 24px;
  @media only screen and (max-width: 768px) {
  } ;
`;

const TableContainer = styled.div`
  margin-top: 20px;
  display: grid;
  gap: 30px;
`;

const FiltersContainer = styled.div`
  display: flex;
  gap: 36px;
  margin-top: 30px;
  width: 1093px;
`;

const FilterButton = styled.div`
  /* cursor: pointer; */
  background: var(--secondary-alice-blue);
  border-radius: 8px;
  padding: 8px 21px;
  display: flex;
  justify-content: center;
  color: var(--primary-royal-blue);
  font-weight: 600;
  display: flex;
  gap: 10px;
  transition: 300ms;
  &:hover {
    /* opacity: 0.8; */
  }
`;

//==== DATA ====//
const DataContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 36px;
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
    gap: 12px;
    & span b{
      width: 100%;
      text-align: left !important;
    }
  } ;
`;

const DataText = styled.span`
  background: var(--secondary-alice-blue);
  color: var(--primary-royal-blue);
  border-radius: 8px;
  padding: 8px 12px;
  display: flex;
  justify-content: center;
  font-weight: 600;
  display: flex;
  gap: 10px;
  transition: 300ms;
  & > div {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 10px;
  }
  @media only screen and (max-width: 1024px) {
    width: 100%;
  } ;
`;
